import { useModal } from '@blueprint/ui';
import {
    trackCloseMenuModal,
    trackCloseShareModal,
    trackOpenMenuModal,
    trackOpenShareModal
} from './SavedListingCard.tracking';

export const useSavedListingCardModals = () => {
    const onCloseMenuModal = () => {
        trackCloseMenuModal();
    };

    const onCloseShareModal = () => {
        trackCloseShareModal();
        if (menuModalIsShowing) {
            closeMenuModal();
        }
    };

    const [menuModalIsShowing, _openMenuModal, closeMenuModal] = useModal({
        onClose: onCloseMenuModal
    });
    const [shareModalIsShowing, _openShareModal, closeShareModal] = useModal({
        onClose: onCloseShareModal
    });

    const openMenuModal = () => {
        _openMenuModal(null);
        trackOpenMenuModal();
    };

    const openShareModal = () => {
        _openShareModal(null);
        trackOpenShareModal();
    };

    return {
        menuModalIsShowing,
        closeMenuModal,
        shareModalIsShowing,
        closeShareModal,
        openMenuModal,
        openShareModal
    };
};
